import React, { use, useCallback, useEffect, useRef, useState } from "react";
import { Box, Container, Chip, Stack, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import CreatePost from "./CreatePost";
import OpenCreatePostCard from "./CeateMainPostCard";
import { detail_feed_api, get_feeds_list } from "../../DAL/feed/feed";
import PageLoading from "../../components/loader/PageLoading";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import PostCard from "../../components/cards/PostCard";
import { useIds } from "../../hook/AdminContext";
import { useLocation, useParams } from "react-router-dom";
import FeedSkeletonLoader from "../../components/loader/Feedskeltonloader";
import UpgradeModal from "../../components/popUp/UpgradeModal";

const categories = ["All", "Resources", "Announcement", "News", "General Feed"];

function FeedListing({ userInfo, previewLink, setPreviewLink }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const feedId = queryParams.get("feed_id");

  const { adminSetting, setUpdateFeedOnNotification } = useIds();
  const { enqueueSnackbar } = useSnackbar();
  const params = useParams();
  const sourceSlug = params?.source_slug || "";

  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [feedsList, setFeedsList] = useState([]);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingSection, setIsLoadingSection] = useState(true);
  const [feedType, setFeedType] = useState("general");
  const [formAction, setFormAction] = useState("ADD");
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [selectedFeed, setSelectedFeed] = useState({});
  const [conditionMetOnce, setConditionMetOnce] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [detailData, setDetailData] = useState(null);
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

  const [loadMore, setLoadMore] = useState(
    "api/feed/feed_list?page=0&limit=50"
  );

  const observer = useRef();

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages > pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer]
  );

  const handleSelectedImage = (post, index) => {
    setSelectedIndex(index);
  };

  const handleOpenImageBox = () => {
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }
    setFormAction("ADD");
    setFeedType("image");
    setOpenCreateModal(true);
  };

  const handleOpenVideoBox = () => {
    // Check if user has payment transaction
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }
    setFormAction("ADD");
    setFeedType("video");
    setOpenCreateModal(true);
  };

  const typeValue = {
    Resources: "resources",
    News: "news",
    Announcement: "annoucement",
    "General Feed": "general",
    All: "",
  };

  const getFeedsListing = async () => {
    try {
      const res = await get_feeds_list(loadMore, sourceSlug);

      if (res.code !== 200) {
        enqueueSnackbar(res.message, { variant: "error" });
        return;
      }
      setFeedsList((prev) => {
        const merged = isLoadingMore ? [...prev, ...res.feeds] : res.feeds;

        // remove duplicates
        return merged.filter(
          (item, index, arr) =>
            arr.findLastIndex((x) => x._id === item._id) === index
        );
      });

      setPageNumber((prev) => prev + 1);
      setTotalPages(res?.feed_count);
      setLoadMorePath(res?.load_more);
    } finally {
      setIsLoadingMore(false);
      setIsLoadingSection(false);
    }
  };

  const fetchAndUpsertFeedDetail = async () => {
    if (!feedId) return;

    const res = await detail_feed_api(feedId);

    if (res?.code !== 200 || !res?.feed) return;

    const updatedFeed = res.feed;

    setFeedsList((prev) => {
      const exists = prev.some((item) => item._id === updatedFeed._id);

      if (exists) {
        // update only
        return prev.map((item) =>
          item._id === updatedFeed._id ? { ...item, ...updatedFeed } : item
        );
      }

      // insert on top if missing
      return [updatedFeed, ...prev];
    });
  };

  const user_info = JSON.parse(localStorage.getItem("user")) || null;

  const getFeedsListingOnAddFeed = async (path) => {
    setIsLoadingSection(true);
    const result = await get_feeds_list(path, sourceSlug);
    if (result.code === 200) {
      setFeedsList(result?.feeds);
      setPageNumber(0);
      setTotalPages(result?.feed_count);
      setLoadMorePath(result?.load_more);
      setIsLoadingMore(false);
      setIsLoadingSection(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoadingMore(false);
      setIsLoadingSection(false);
    }
  };

  // useEffect(() => {
  //   fetctUserDetails();
  // }, []);

  const getFeedsListingOnDelete = async (id) => {
    const data = feedsList.filter((feed) => feed._id !== id);
    setFeedsList(data);
  };

  const loadMoreData = () => {
    setIsLoadingMore(true);
    setLoadMore(loadMorePath);
  };

  const handleOpenSimpleBox = () => {
    // Check if user has payment transaction
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }
    setFormAction("ADD");
    setFeedType("general");
    setOpenCreateModal(true);
  };
  const handleFeedEdit = (selected_feed) => {
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }

    setFormAction("EDIT");
    setSelectedFeed(selected_feed);
    setOpenCreateModal(true);
  };

  const handleUpdateSpecificFeed = (updatedFeed, setList = setFeedsList) => {
    if (updatedFeed && updatedFeed.deleted_feed_id) {
      setList((prev) =>
        prev.filter((obj) => obj._id !== updatedFeed.deleted_feed_id)
      );
      return;
    }
    setList((prev) =>
      prev.map((item) =>
        item._id === updatedFeed._id ? { ...item, ...updatedFeed } : item
      )
    );
  };

  useEffect(() => {
    if (!isLoadingMore) {
      setIsLoadingSection(true);
    }
    getFeedsListing();
  }, [loadMore, sourceSlug, userInfo?.profile_id]);

  useEffect(() => {
    if (feedId) {
      fetchAndUpsertFeedDetail();
    }
  }, [feedId]);

  useEffect(() => {
    // Register the function
    setUpdateFeedOnNotification(() => (data) => {
      handleUpdateSpecificFeed(data, setFeedsList);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateFeedOnNotification(() => () => {});
    };
  }, [feedsList]);

  const user = localStorage.getItem("user");
  const data = user ? JSON.parse(user) : null;
  return (
    <div className="">
      {((userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.feed?.add)) && (
        <>
          <OpenCreatePostCard
            handleOpenSimpleBox={handleOpenSimpleBox}
            userInfo={userInfo}
            data={data}
            handleOpenImageBox={handleOpenImageBox}
            handleOpenVideoBox={handleOpenVideoBox}
            detailData={detailData}
            previewLink={previewLink}
            setPreviewLink={setPreviewLink}
          />
        </>
      )}
      {((userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          (userInfo?.company_access?.feed?.add ||
            userInfo?.company_access?.feed?.update))) && (
        <>
          {openCreateModal && (
            <CreatePost
              setFeedType={setFeedType}
              feedType={feedType}
              openCreateModal={openCreateModal}
              setOpenCreateModal={setOpenCreateModal}
              userInfo={userInfo}
              getFeedsListing={getFeedsListingOnAddFeed}
              selectedFeed={selectedFeed}
              type={formAction}
              setFormAction={setFormAction}
              previewLink={previewLink}
              setPreviewLink={setPreviewLink}
            />
          )}
        </>
      )}

      {/* Upgrade Modal */}
      <UpgradeModal
        open={openUpgradeModal}
        handleClose={() => setOpenUpgradeModal(false)}
      />

      {/* <Stack
          className="stack-overflow"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "20px",
            paddingLeft: "10px",
          }}
          direction="row"
          spacing={1}
          overflow="auto"
        >
          {categories.map((category) => (
            <Chip
              key={category}
              label={category}
              className="pointer"
              onClick={() => {
                setFeedsList([]);
                setSelectedCategory(category);
              }}
              sx={{
                marginTop: "15px !important",
                border: "1px solid #0000002d !important",
                cursor: "pointer",
                backgroundColor:
                  selectedCategory === category
                    ? "var(--portal-primary-color) !important"
                    : "inherit !important",
                color:
                  selectedCategory === category ? "#fff !important" : "default",
              }}
            />
          ))}
        </Stack> */}
      {isLoadingSection ? (
        <FeedSkeletonLoader />
      ) : (
        <>
          {feedsList && feedsList.length > 0 ? (
            <div className="feed-list-wrapper">
              {feedsList.map((post) => (
                <PostCard
                  key={post?._id}
                  post={post}
                  handleFeedEdit={handleFeedEdit}
                  formAction={formAction}
                  handleSelectedImage={handleSelectedImage}
                  getFeedsListingOnDelete={getFeedsListingOnDelete}
                  selectedIndex={selectedIndex}
                  setSelectedIndex={setSelectedIndex}
                  feedsList={feedsList}
                  type={formAction}
                  handleUpdateSpecificFeed={handleUpdateSpecificFeed}
                />
              ))}
            </div>
          ) : (
            <div className="mt-5">
              <RecordNotFound title="Feed Not" />
            </div>
          )}
        </>
      )}

      {!isLoadingSection && totalPages > pageNumber ? (
        <div className="col-12 text-center favourite-buttton-box">
          <div
            ref={lastBookElementRef}
            className="mt-3"
            onClick={loadMoreData}
            id="load-more-feed"
          >
            {isLoadingMore ? <CircularProgress size={15} /> : "Load More"}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default FeedListing;
